import { FormResponse } from "@tellescope/types-models";
import { useEnduserCurrentEnduser, useEnduserStore } from "../../../store/hooks";
import { useOrganization } from "../../../../shared/store/organizationStore";
import { EnduserFormWizard, type EnduserFormWizardProps, type FormSurface } from "@tellescope/forms";
import { PrintResponseButton } from "./PrintResponseButton";

interface PendingFormContentProps {
  formResponse: FormResponse;
  onComplete: () => void;
  continueToFormInApp?: EnduserFormWizardProps["continueToFormInApp"];
  surface: FormSurface;
  automationStepId?: string;
  documentGroupBackUrl?: string;
  publicIdentifier?: string;
  restartUrl?: string;
}

export const PendingFormContent = ({
  formResponse,
  onComplete,
  continueToFormInApp,
  surface,
  automationStepId,
  documentGroupBackUrl,
  publicIdentifier,
  restartUrl,
}: PendingFormContentProps) => {
  const currentEnduser = useEnduserCurrentEnduser();
  const session = useEnduserStore((state) => state.session);
  const organization = useOrganization();

  const enduserId = currentEnduser?.id ?? formResponse.enduserId;

  if (!formResponse.accessCode || !currentEnduser) {
    return null;
  }

  return (
    <EnduserFormWizard
      formArgs={{
        formId: formResponse.formId,
        responseId: formResponse.id,
        enduserId,
        parentResponseId: formResponse.parentResponseId,
        rootResponseId: formResponse.rootResponseId,
        existingResponses: formResponse.responses,
        accessCode: formResponse.accessCode ?? "",
        publicIdentifier: publicIdentifier ?? formResponse.publicIdentifier,
        enduser: currentEnduser,
        automationStepId,
      }}
      surface={surface}
      onComplete={onComplete}
      session={session}
      organizationSubdomain={organization?.subdomain}
      organization={organization ?? undefined}
      continueToFormInApp={continueToFormInApp}
      documentGroupBackUrl={documentGroupBackUrl}
      restartUrl={restartUrl}
      renderDownloadAction={(submittedResponse) => <PrintResponseButton formResponse={submittedResponse} />}
    />
  );
};
